import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import Checkbox from '@mui/material/Checkbox'
import dayjs from 'dayjs'
import { hasPermission } from 'hooks/useBackendMenu'
import React from 'react'
import { valoresValeAlimentacao } from 'service/api'
import { axiosInstance } from 'service/api/axios'
import { toast } from 'sonner'
import { useStore } from 'store'

const AlterarPagamento: React.FC<GridCellParams> = ({ value, row }) => {
    const empresaId = useStore(state => state.companyId)

    const handleChange = (_: any, checked: boolean) => {
        axiosInstance
            .put('/v1/vale-alimentacao/pagar', {
                empresaId,
                funcionarioId: row.funcionarioId,
                data: dayjs.utc(row.data).toDate(),
                pagar: checked,
            })
            .then(async () => {
                await valoresValeAlimentacao.invalidateQueries()
                toast.success('Pagamento atualizado com sucesso')
            })
            .catch(error => {
                toast.error('Erro ao atualizar pagamento')
                console.error(error)
            })
    }

    return (
        <Checkbox
            color="primary"
            onChange={handleChange}
            defaultChecked={value}
            disabled={!hasPermission(['update', 'ValeAlimentação'])}
        />
    )
}

export default AlterarPagamento
